import {
  AlertComponent
} from './alert.component';
import {
  Injectable,
  ComponentFactoryResolver,
  ComponentFactory,
  ComponentRef,
  ViewContainerRef
} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  alertComponentRef: ComponentRef<AlertComponent>;

  constructor(private resolver: ComponentFactoryResolver) { }
/**
 * 
 * @param refContainer 
 * @param options
 */
  public openAlert(refContainer: ViewContainerRef, options: any) {
    refContainer.clear();
    const alertFactory: ComponentFactory<AlertComponent> = this.resolver.resolveComponentFactory(
      AlertComponent
    );    
    this.alertComponentRef = refContainer.createComponent(alertFactory);
    this.alertComponentRef.instance.alertService = true;
    this.setOptions(options);
  }

  setOptions(options: any) {    
    for (const property in options) {
      if (property !== 'content') {
        this.alertComponentRef.instance[property] = options[property];
      } else if (property === 'content') {
        this.alertComponentRef.instance.content = options.content;
      }

      if (options.type === 'accordion') {
        this.alertComponentRef.instance.alertHeadingRight = options.alertHeadingRight ? options.alertHeadingRight :false;
      } else if (options.type === 'notification') {
        this.alertComponentRef.instance.isNotificationVisible = true;
      }
      if (options.autoClose) {
        this.alertComponentRef.instance.openAlert();
      }
    }
  }

  public closeAlert() {
    this.alertComponentRef.instance.close();
  }
}